import { Component, OnInit,ViewChild } from '@angular/core';
// import { ListColumn } from '../../core/list/list-column.model';
// import { MatTableDataSource, MatSort, MatPaginator } from '@angular/material';
// import { Role } from './../settings/view-userdetails/view-userdetails.component';
// import { FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
// import { MatDialog } from '@angular/material';

// import { SuccessPopupComponent } from '../success-popup/success-popup.component';
import { CommonFunctionService, UserPOSData} from '../../../services/Common/common-function.service';
// import { DatePipe } from '@angular/common';
// import { Z_DATA_ERROR } from 'zlib';

import { DatePipe } from '@angular/common';
import { DatatableComponent } from '@swimlane/ngx-datatable';
const _clone = (d) => JSON.parse(JSON.stringify(d));
import { environment } from '../../../../environments/environment';
import { CustomerService } from '../../POSServices/Customers/customer.service';


@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss']
})
export class OrderDetailComponent implements OnInit {
  currency:any;
  ItemAmount=0;
  PaymentStatusinfo:boolean=false;
  myItems=[];
  paymenturl:boolean=false;
  private newAttribute: any = {};
  PaymentProcessUrl:any;
  // customerinfo
  printoption:boolean=false;
  cashtransactiondetails:boolean=false;
  ReturnAmount:any;
  tenderAmount:any;
  transactiondetails:boolean=false;
  CustomerID :any;
  Customername :any;
 CustomerEmail  :any;
 Customermobile  :any;
  CustomerAddresss  :any;
  OrderAmount:any;
  
  merchantdata: UserPOSData ;
  // @ViewChild(MatPaginator) paginator: MatPaginator;
  // @ViewChild(MatSort) sort: MatSort;
  row=[];
  Itemslist=[];
  PosSubscriptionId:any;
  id:any;
  OrderId:any;
  TenderType:any;
  LineItemCount:any;
  LineItemTotalAmount:any;
  TaxAmount:any;

  ShippingAmount:any;
  AdditionalCharge:any;
  TipAmount:any;
  DiscountAmount:any;
  TotalNetAmount:any;
  OrderSource:any;
  OrderStatus:any;
  PaymentStatus:any;
  PaymentId:any;
  ItemDescription:any;
 
  OrderDetails:any;
  ItemCategory:any;
  Quantity:any;
  ItemPrice:any;
  TaxType:any;
  DisCountAmount:any;
  DisCountType:any;
  ItemId:any;
  TotalNetItemAmount:any;


  // columns: ListColumn[] = [
  //   { name: 'ItemCategory', property: 'ItemCategory', visible: false, isModelProperty: true },
  //   { name: 'Quantity', property: 'Quantity', visible: true, isModelProperty: true },
  //   { name: 'ItemPrice', property: 'ItemPrice', visible: true, isModelProperty: true },   
  //   { name: 'TotalNetItemAmount', property: 'TotalNetItemAmount', visible: true, isModelProperty: true },
  //   { name: 'ItemDescription', property: 'ItemDescription', visible: true, isModelProperty: true },
  // ] as ListColumn[];


  AlldataSource;
  posId: any;
  rows = [];
  temp = [];
  constructor(  private router: Router,
    private activatedRoute: ActivatedRoute,
    private service: CustomerService,
    
    private commonfunction: CommonFunctionService) {
      let merchantdata: UserPOSData=this.commonfunction.getUserPOSData();
      this.currency = this.commonfunction.GetCurrencysymbol();
      this.posId= merchantdata.PosSubscriptionId;
    //   this.getOrerDetails((data) => {
    //     // cache our list
    //     this.temp = _clone(data);
    //     this.rows = _clone(data);
    // });

     }

  ngOnInit() {
    this.merchantdata = this.commonfunction.getUserPOSData();
    this.getGetOrderDetails();
 
  }

  
  generateEBill(){
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"",orderId:""};
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      form.id = params["orderid"];
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
    });
    this.service.CallGenerateEinvoice(form).subscribe(result => {
            this.service.PrintEwayBillDetails(result).subscribe(res=>{
            var fileURL = URL.createObjectURL(res);
            console.log('scope is', fileURL);
            console.log('pdf', res);
            window.open(fileURL);
        });
      });
  }


  getGetOrderDetails() {
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"",orderId:""};
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      form.id = params["orderid"];
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;

      console.log("formdata---" + form);
    });   
    this.service.GetOrderdetails(form).subscribe(result => {   
      console.log("result.Id---" + result);
      if (result.length > 0) {

        // this.Itemslist= _clone(result.itemDetails);
        for(let i=0;i<result.length;i++)
        {
        var ProductCode= result[i].productCode;
          var ItemId=result[i].ItemId
           var itemDescription=result[i].ItemDescription;
           var itemName=result[i].ItemName;
           var itemCategory=result[i].ItemCategory;
           var  quantity=result[i].Quantity
           var itemPrice=result[i].ItemPrice;
              var taxrate=result[i].ItemTaxAmount

              // var  taxamount=itemPrice*quantity*taxrate/100;
              var  taxamount=result[i].ItemTaxAmount;
              var ItemAmount=result[i].TotalNetItemAmount;


          this.newAttribute = {ItemId,itemDescription,itemName,itemCategory,quantity,itemPrice,taxrate,ProductCode,taxamount,ItemAmount}; 
          this.myItems.push(this.newAttribute); 
        }
       
        this.rows=this.myItems;

        for(let i=0;i<this.rows.length;i++)
          {
            this.ItemAmount=this.ItemAmount+this.rows[i].itemPrice*this.rows[i].quantity;
          }
        this.OrderId=result[0].OrderId;
        this.PosSubscriptionId = result[0].PosSubscriptionId;
        this.OrderId = result[0].OrderId;
        this.TenderType = result[0].TenderType;
        this.PaymentProcessUrl=result[0].PaymentProcessUrl;

        if(this.TenderType==1)
        {
       this.PaymentStatusinfo=false;
          this.printoption=true;
          form.orderId=this.OrderId;
          this.TenderType = "Cash";
          this.service.GetCashTransactionDetail(form).subscribe(result => { 
            if(result !=null)
            {
              this.cashtransactiondetails=true;
              this.OrderAmount=result.OrderAmount;
              this.tenderAmount=result.TenderAmount;
              this.ReturnAmount=result.ReturnAmount;

            
            }
          });
        }
        
       else if(this.TenderType==2)
        {
          this.TenderType = "CreditCard";
          
        }
        else if(this.TenderType==3)
        {
          this.TenderType = "DebitCard";
        }
        else if(this.TenderType==4)
        {
          this.TenderType = "Wallet";
        }
        else if(this.TenderType==5)
        {
          this.TenderType = "NetBanking";
        }
        else if(this.TenderType==6)
        {
          this.TenderType = "PrepaidCard";
        }
        else if(this.TenderType==7)
        {
          this.TenderType = "Upi";
        }
        else{
          this.TenderType = "Draft";
        }
        
        this.LineItemCount = result[0].LineItemCount;
        this.LineItemTotalAmount =result[0].LineItemTotalAmount;
        this.TaxAmount = result[0].TaxAmount;
        if(this.TaxAmount ==0)
        {
          this.TaxAmount="0"
        }
        this.ShippingAmount = result[0].ShippingAmount; 
        if(this.ShippingAmount ==0)
        {
          this.ShippingAmount="NA"
        }   
        this.AdditionalCharge = result[0].AdditionalCharge;
        if(this.AdditionalCharge ==0)
        {
          this.AdditionalCharge="NA"
        } 
        this.TipAmount= result[0].TipAmount;
        if(this.TipAmount ==0)
        {
          this.TipAmount="NA"
        }  
        this.DiscountAmount = result[0].DiscountAmount;
        // if(this.DiscountAmount ==0)
        // {
        //   this.DiscountAmount="NA"
        // }  


        // this.ItemAmount=result[0].totalNetAmount-this.TaxAmount
        this.TotalNetAmount = result[0].TotalNetAmount-result[0].DiscountAmount;
        this.OrderSource = result[0].OrderSource;
        this.OrderStatus = result[0].OrderStatus;
        if(this.OrderStatus==1)
        {
          this.OrderStatus="Submitted";
          this.paymenturl=true;
        }  
        else if(this.OrderStatus==2)
        {

          this.OrderStatus="Shipped";
        }
        else if(this.OrderStatus==3)
        {
          this.OrderStatus="Delivered";
        }
        else if(this.OrderStatus==4)
        {
          // this.OrderStatus="Completed";
          this.OrderStatus="Payment Received";
        }
        else if(this.OrderStatus==5)
        {
          // this.OrderStatus="Completed";
          this.OrderStatus="Cancelled";
        }
        this.PaymentStatus = result[0].PaymentStatus;
        if(this.PaymentStatus==1)
        {
          this.PaymentStatus="Approved"
        }
        else if(this.PaymentStatus==2)
        {
          this.PaymentStatus="Declined"
        }
        else if(this.PaymentStatus==4)
        {
          this.PaymentStatus="Submmited"
        }
        else
        {
         
          if(this.OrderStatus=="Completed" && this.TenderType=="Cash")
          {
            
            this.PaymentStatus="Approved"
          }
          else{
            this.PaymentStatus="Pending"
          }
         
        }
        this.PaymentId = result[0].PaymentId;
        if(this.PaymentId !=null)
        {
          this.transactiondetails=true;
        }
       this.CustomerID =result[0].CustomerId;
       this.Customername =result[0].CustomerName
       this.CustomerEmail =result[0].Email
       this.Customermobile =result[0].MobileNo
       this.CustomerAddresss =result[0].Address
      }    
    });
    
  }
  DownLoadPage() {
    window.print();
  }

 getOrerDetails(cb) {
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"",orderId:""};
    this.activatedRoute.params.subscribe(params => {
      form.id = params["id"];
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      // form.orderId="3434"
      form.orderId=params["orderid"];
    });   

    const req = new XMLHttpRequest();
    req.open('GET',environment.Getdetails + "?OrderId=" +form.orderId);
    req.onload = () => {
        cb(JSON.parse(req.response));
    };
    req.send();
     
   }



  // getOrerDetails() {
  //   let form = { merchantKeyId: "", id: "", PosSubscriptionId:"",orderId:""};
  //   this.activatedRoute.params.subscribe(params => {
  //     console.log(params["id"]);
  //     console.log(params["merchantKeyId"]);
  //     form.id = params["id"];
  //     form.merchantKeyId = params["merchantKeyId"];
  //     form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
  //     form.orderId="3434"
  //     console.log("formdata---" + form);
  //   });   
  //   this.service.Getdetails(form).subscribe(data => {
  //     this.AlldataSource = new MatTableDataSource<Order>(data.map(result => new Order(result)));
  //     this.AlldataSource.paginator = this.paginator;
  //     this.AlldataSource.sort = this.sort;
  //     this.AlldataSource.columns = this.columns;
  //  });
  //  }
  

  copyToClipboard(element) {
    element.select();
    document.execCommand('copy');
  }
}

